<template>
    <div class="map-page" v-if="pageSetup != null">
        <breadcrumbs></breadcrumbs>
        <div class="container">
            <div class="section-title">
                <h1>{{pageSetup.page_title}}</h1>
            </div>
            <salesFilter v-if="currentCity.length"></salesFilter>
        </div>
        <!-- <mapNavigation v-if="currentCity.length"></mapNavigation> -->
        <mapProjects v-if="currentCity.length && pageName == 'sales-map'"></mapProjects>
        <div class="container container-share">
            <sharePostBottom :options="[{title: 'Поделиться данной страницей:', data_title: 'BAZIS-A | Жилые комплексы на карте', data_link: 'https://sales.bazis.kz/sales-map', data_page: 'Комплексы на карте', data_page_key: 'sales_map'}]"></sharePostBottom>
            <BanerBottomVertical :options="[{page: 'sales-map'}]" class="sales-map-vertical-baner-bottom" v-if="banerSystem != undefined && banerSystem.baner_system_active == 'true'"></BanerBottomVertical>
        </div>
    </div>
</template>

<script>
    import BanerBottomVertical from '@/components/baner-system/baner-bottom-vertical.vue'
    import breadcrumbs from '@/components/breadcrumbs/breadcrumbs.vue'
    import sharePostBottom from '@/components/share/share-social-bottom.vue'
    import salesFilter from '@/components/sales/sales-filter.vue'
    import mapProjects from '@/components/sales-map/sales-map-project.vue'
    import {mapGetters} from 'vuex'
    import store from '@/store.js'
    export default {
        name: 'sales-map--page',
        components: {
            breadcrumbs,
            mapProjects,
            salesFilter,
            sharePostBottom,
            BanerBottomVertical,
        },
        data () {
            return {
                title: 'Комплексы на карте',
                crumb: 'Комплексы на карте',
            }
        },
        computed: mapGetters({
            currentCity: 'loadCurrentCity',
            pageSetup: 'loadSalesMapPage',
            pageName: 'loadPageName',
            banerSystem: 'loadBanerSystem',
        }),
        methods: {
            initYmapScript() {
                let recaptchaScript = document.createElement('script')
                recaptchaScript.setAttribute('src', 'https://api-maps.yandex.ru/2.1.75/?apikey=5ec4cf69-f505-4a8a-8b6d-70d1e6402870&lang=ru_RU')
                document.head.appendChild(recaptchaScript)
            },
        },
        beforeRouteEnter (to, from, next) {
            if (store.state.projectItems != null) {
                if (store.state.salesMapPage == null) {
                    store.dispatch('getSalesMapPageData').then((response) => {
                        if (response) {
                            next(vm => {
                                vm.$store.commit('setCustomCrumb', vm.crumb);
                                vm.$store.commit('removePageLoaderImg');
                                vm.$parent.$refs.topProgress.done()
                            });
                        }
                    })
                } else {
                    next(vm => {
                        vm.$store.commit('setCustomCrumb', vm.crumb);
                        vm.$store.commit('removePageLoaderImg');
                        vm.$parent.$refs.topProgress.done()
                    });
                }
            } else {
                store.dispatch('getSalesMapPageData');
                store.dispatch('getProjectsItems').then((response) => {
                    // console.log(resp, 'HOME')
                    if (response) {
                        next(vm => {
                            vm.$store.commit('setCustomCrumb', vm.crumb);
                            vm.$store.commit('removePageLoaderImg');
                            vm.$parent.$refs.topProgress.done()
                        });
                    } else {
                        next(false, vm => vm.$parent.$refs.topProgress.fail());
                    }
                });
            }
        },
        beforeCreate() {
            // this.$store.dispatch('getSalesMapPageData');
            // this.$store.dispatch('getProjectsItems');
            document.body.dataset.page = 'sales-map';
        },
        created () {
            // this.initYmapScript();
            document.title = this.title;
        },
        mounted() {
        }
    }
</script>